import React, { useEffect } from "react";

import "./Devlog.css";

// import global components
import PageHeading from "../../components/PageHeading/PageHeading";

// importing local components:
import DevlogCard from "./components/DevlogCard/DevlogCard";

// importing local data:
import { devlogData } from "./data/devlogData";

const Devlog = ({ setPageTitle }) => {
  useEffect(() => {
    setPageTitle(["My", " Devlog"]);
    window.scrollTo(0, 0);
  }, [setPageTitle]);

  return (
    <section className="devlog-section-container">
      <PageHeading heading={["Dev", "log"]} pageName={"Videos"} />

      <div className="devlogs-container">
        {devlogData?.map((devlog, index) => (
          <DevlogCard key={index} devlogInfo={devlog} count={index + 1} />
        ))}
      </div>
    </section>
  );
};

export default Devlog;
